import React, { Component } from "react"
import { TestTimeIndicator } from "../../services/utils/practice-test-util"
import SprintWelcomePage from "./SprintWelcomePage"
import SprintOverPage from "./SprintOverPage"
import TimedSprintACT from "./TimedSprintACT"
import { SprintsRest } from "../../services/sprints/sprints-rest-interface"

interface Props {
    userInfo: any
    testId: string
    fullSprintInfo: any
    onTestExit: (testName: string) => void
}

interface State {
    currentStep: number
    testTimeIndicator: TestTimeIndicator
    initializing: boolean
    error: string
}

export default class SprintsWorkflow extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        let saved = props.fullSprintInfo.userTimedSprint
        this.state = {
            currentStep: saved ? (saved.remainingTimeInSeconds === 0 ? 2 : 1) : 0,
            testTimeIndicator: saved ? saved.testTimeIndicator : "regular",
            initializing: false,
            error: "",
        }
    }

    handleTestTimeSelection = async (testTimeIndicator: TestTimeIndicator) => {
        if (this.state.initializing) return
        this.setState({initializing: true, error: ""})
        try {
            await SprintsRest.initializeSprint(this.props.testId, testTimeIndicator)
            this.setState({currentStep: 1, testTimeIndicator, initializing: false})
        } catch (error) {
            this.setState({initializing: false, error: "Unable to start the sprint. Please try again."})
        }
    }

    handleTestExit = () => this.props.onTestExit(this.props.testId)

    render() {
        let {currentStep, testTimeIndicator, initializing, error} = this.state
        let {testId, userInfo, fullSprintInfo} = this.props
        let {timedSprint} = fullSprintInfo
        let {sprintNumber, subject} = timedSprint
        let shortSprintInfo = `Sprint  ${sprintNumber}`
        let title = `Welcome to ${subject} ${shortSprintInfo}`
        let sprintOverTitle = `${subject} ${shortSprintInfo} is Over`

        return <>
            {error && <div role="alert">{error}</div>}
            {initializing && <div role="status">Starting sprint…</div>}
            {currentStep === 0 && <SprintWelcomePage title={title} shortSprintInfo={shortSprintInfo} onTimeSelected={this.handleTestTimeSelection} />}
            {currentStep === 1 && <TimedSprintACT key={testId} timedSprintId={testId} testTimeIndicator={testTimeIndicator}
                userInfo={userInfo} onNext={() => this.setState({currentStep: 2})} onTestExit={this.handleTestExit} />}
            {currentStep === 2 && <SprintOverPage title={sprintOverTitle} onPageShown={() => {}} onNext={this.handleTestExit} />}
        </>
    }
}
